<template>
  <div class="about font-primary">
    <Carousel id="carousel" />
    <p
      title="presione para borrar"
      v-if="filtroBusqueda"
      class="text-gray-500 text-left px-10 absolute hover:cursor-pointer"
      @click="cargarProductos(1)"
    >
      Busqueda actual > {{ filtroBusqueda }}
    </p>
    <div v-if="esVendedor" class="flex flex-wrap justify-center items-center p-2">
      <input type="text" class="form-control w-44" v-model="filtroClientes" @change="updateIdcli()" placeholder="Buscar cliente..">
      <div v-if="esVendedor" class="flex flex-wrap justify-center items-center p-2">
        <p>Cliente: </p>
        <select placeholder="Seleccione un cliente" class="form-select w-72" v-model="idcli" @change="itemsCarrito()">
          <option value="" disabled selected hidden>Seleccione un cliente</option>
          <option v-for="(ex, key) in clientesFiltrados" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
        </select>
      </div>
    </div>
    <div class="flex w-full justify-around py-8 flex-wrap gap-y-2">
      <div class="flex">
        <input
          type="text"
          @disabled="cargando"
          @change="cambioBuscador(1)"
          v-model="buscador"
          class="form-control w-40 md:w-72"
          placeholder="Buscar..."
          aria-label="Buscar"
          aria-describedby="basic-addon1"
        />
        <div
          @disabled="cargando"
          @click="cambioBuscador(1)"
          class="bg-red-500 rounded-r"
        >
          <img
            class="w-10"
            src="../assets/icons/search.png"
            alt="icono de busqueda"
          />
        </div>
      </div>
      <div class="flex flex-wrap items-center gap-2">
        <input
          type="number"
          @change="buscarRango(1)"
          id="desde"
          class="form-control w-44"
          placeholder="Precio desde"
          v-model="precioDesde"
        />
        <p>-</p>
        <input
          type="number"
          @change="buscarRango(1)"
          class="form-control w-44"
          placeholder="Precio hasta"
          v-model="precioHasta"
        />
      </div>
      <div class="flex items-center gap-2">
        <p>Orden</p>
        <select
          class="form-select w-44"
          @change="cambioOrdenPrecio(1)"
          v-model="orden"
        >
          <option value="pd">Por defecto</option>
          <option value="pMm">Precio mayor a menor</option>
          <option value="pmM">Precio menor a mayor</option>
        </select>
      </div>
    </div>
    <div class="flex w-full">
      <div class="flex w-full items-start flex-wrap" :class="{'md:w-5/6': this.banner, 'md:w-full': !this.banner}">
        <div class="md:w-1/5 w-full border-black-500 border-t border-r text-left px-2">
          <div v-for="(marca, key) in categorias" :key="key">
            <p
              @click="toggleMarca(key)"
              class="bg-truered rounded text-white pl-4 hover:cursor-pointer"
            >
              {{ marca.marca }}
            </p>

            <p
              v-if="expandedMarcas[key]"
              @click="buscarCategoria(1, marca.marca, marca.idmarca)"
              class="text-red-500 hover:cursor-pointer pl-8"
            >
              Ver todos los productos
            </p>
            <div v-if="expandedMarcas[key]">
              <div v-for="(categoria, i) in marca.categorias" :key="i">
                <p v-if="categoria.subCategorias.length > 0"
                  @dblclick="
                    buscarCategoria(
                      1,
                      categoria.categoria,
                      marca.idmarca,
                      categoria.idcat
                    )
                  "
                  title="doble click para seleccionar"
                  @click="toggleCategoria(key, i)"
                  :class="{
                    'bg-gray-300': categoria.subCategorias.length > 0,
                    rounded: true,
                    'pl-6': true,
                    'hover:cursor-pointer': true,
                  }"
                >
                  {{ categoria.categoria }}
                </p>
                <p v-else @click="
                    buscarCategoria(
                      1,
                      categoria.categoria,
                      marca.idmarca,
                      categoria.idcat
                    )
                  "
                  :class="{
                    'bg-gray-300': categoria.subCategorias.length > 0,
                    rounded: true,
                    'pl-6': true,
                    'hover:cursor-pointer': true,
                    'hover:underline': true
                  }"
                >
                  {{ categoria.categoria }}</p>

                <div v-if="expandedCategorias[key] && expandedCategorias[key][i]">
                  <div v-for="(subCat, q) in categoria.subCategorias" :key="q">
                    <p
                      @click="
                        buscarCategoria(
                          1,
                          subCat.subcategoria,
                          marca.idmarca,
                          categoria.idcat,
                          subCat.idsubcat
                        )
                      "
                      class="pl-8 hover:cursor-pointer hover:underline"
                    >
                      {{ subCat.subcategoria }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="md:w-4/5 w-full h-auto flex flex-wrap justify-center md:justify-start items-start border-black-500 border-l">
          <p class="text-red-500 w-full" v-if="errorItem">{{ errorItem }}</p>
          <div v-for="(item, key) in items" :key="key" class="h-full py-2">
            <div
              class="flex flex-col border-b-4 border-transparent hover:border-red-500 transform transition-transform hover:scale-105 duration-500 mx-2 max-w-[180px]"
            >
              <div
                class="flex justify-center clickable h-[125px]"
                @disabled="cargando"
                @click="cargarModalClickItem(key)"
              >
                <div v-if="item.OFERTA_IO">
                  <div class="image-container">
                    <img :src="item.imagen1" alt="Product Image" />
                    <div class="sale-banner">PROMO</div>
                  </div>
                </div>
                <!-- <img src="" class="text-center w-32"> -->
                <div v-else>
                  <img
                  class="w-32 h-[125px] object-contain"
                  v-if="item.imagen1"
                  :src="item.imagen1"
                  alt="Imagen del articulo"
                  />
                  <img
                  class="w-32 h-[125px] object-contain"
                  v-else
                  src="../assets/no-photo.jpg"
                  alt="Imagen del articulo"
                  />
                </div>
              </div>
              <div class="w-full h-full py-2">
                <p class="text-center text-[11px]">Art. {{ item.CODIGO_ART }} <b v-if="item.DESTACADO_IO" class="text-red-500">FUTURO</b></p>
                <p class="text-center text-sm h-[55px] ">{{ item.DESCRIP_ART }}</p>
                <p class="text-[11px] whitespace-nowrap">Bulto: {{ item.UXB }} - {{ item.interno ? 'Int: ' +  item.interno + ' - ' : ''  }} {{ item.surtido }}</p>
                <div class="flex justify-center gap-1 items-center">
                  <div v-if="item.DESCUENTO_IO" class="flex items-center gap-1 h-[32px]">
                    <p class="text-[10px] text-gray-600 line-through">
                      ${{ item.PRECIO_LPI.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}
                    </p>
                    <p class="text-sm text-red-600">
                      ${{ (item.PRECIO_LPI * (1 - (Number(item.DESCUENTO_IO) / 100))).toFixed(2) }}
                    </p>
                  </div>
                  <div v-else class="flex items-center gap-1 h-[32px]">
                    <p class="text-sm text-red-600">
                      ${{ item.PRECIO_LPI.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}
                    </p>
                  </div>
                  <img v-if="item.INDICACION_IO" class="h-5 w-auto rounded-full p-1 border-black border hover:bg-gray-300 shadow-lg bg-truered" src="../assets/icons/tooltip.png" alt="indicacion" :title="item.INDICACION_IO">
                </div>
                <div class="flex align-center justify-around gap-1">
                  <label :for="'cant' + key" class="text-xs">Cant.</label
                  ><input
                    :title="(item.multiplo && item.multiplo != 1) ? ('Venta de ' + item.multiplo + ' unidades o multiplo') : ''"
                    :id="'cant' + key"
                    class="w-10 border-gray-500 border-1 rounded input-number"
                    min="1"
                    @change="agregar(item)"
                    type="number"
                    @disabled="cargando"
                    @focus="item.cantidadPedida == 0 ? item.cantidadPedida = '' : null"
                    @blur="!item.cantidadPedida ? item.cantidadPedida = 0 : null"
                    v-model="item.cantidadPedida"
                  /><button
                    @disabled="cargando"
                    @click="agregar(item)"
                    class="btn btn-custom-secondary btn-sm"
                  >
                    AGREGAR
                  </button>
                </div>
                <div class="flex align-center py-1" v-if="esVendedor">
                  <input
                    @disabled="cargando"
                    class="border-gray-500 border-1 rounded"
                    placeholder="Observacion"
                    type="text"
                    v-model="item.obs"
                  />
                </div>
              </div>
            </div>
          </div>
          <div ref="catalogScrollSentinel" class="h-px w-full basis-full"></div>
          <p v-if="cargando && items.length > 0" class="w-full text-center py-4 text-gray-500 basis-full">Cargando más artículos...</p>
          <div class="w-full" v-if="items.length == 0">
            <div class="w-full flex justify-center">  
              <p class="font-primary" >No se encuentran items para esta condición de busqueda</p> <br>
            </div>
            <button class="btn btn-danger btn-sm mt-4" @click="cargarProductos(1)">Borrar filtros de busqueda</button>
          </div>
        </div>
      </div>
      <div v-if="this.banner" class="hidden md:block sticky top-20 relative w-1/6 h-full">
        <img class="max-h-96" :src="this.banner" alt="banner">
      </div>
    </div>


    <!-- Modal click items ----------------------------------------------------------------------------------->
    <div
      class="modal modal-xl fade"
      id="modalClickItem"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body flex flex-wrap items-center justify-between">
            <div class="w-full md:w-6/12">
              <div>
                <div id="myCarousel" class="carousel slide">
                  <!-- Slides -->
                  <div class="carousel-inner">
                    <div
                      v-for="(item, index) in modalClickItemData.carousel"
                      :key="index"
                      :class="{
                        'carousel-item': true,
                        active: index === thumbnailIndex,
                      }"
                    >
                      <div v-if="!item.split('|')[0]">
                        <img
                          class="d-block w-100 max-h-[400px] object-contain"
                          src="../assets/no-photo.jpg"
                          alt="Imagen del articulo"
                        />
                      </div>
                      <div v-else>
                        <img
                          v-if="isImage(item)"
                          :src="item.split('|')[0]"
                          :alt="'Slide ' + (index + 1)"
                          class="d-block w-100 max-h-[400px] object-contain scale-100 hover:scale-150"
                        />
                        <video
                          v-else
                          controls
                          class="d-block w-100 max-h-[400px] object-contain"
                        >
                          <source :src="item.split('|')[0]" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>

                  <!-- Controls -->
                  <a
                    class="carousel-control-prev h-2/4 mt-10 hover:bg-gray-200"
                    href="#myCarousel"
                    role="button"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next h-2/4 mt-10 hover:bg-gray-200"
                    href="#myCarousel"
                    role="button"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </a>
                </div>
                <!-- Indicators -->
                <ol class="w-full flex justify-center mt-2 gap-1">
                  <li
                    v-for="(item, index) in modalClickItemData.carousel"
                    :key="index"
                    :data-bs-target="'#myCarousel'"
                    :data-bs-slide-to="index"
                    :class="{ active: index === thumbnailIndex }"
                    @click="selectThumbnail(index)"
                  >
                    <div v-if="!item.split('|')[0]">
                      <img
                        src="../assets/no-photo.jpg"
                        :alt="'Slide ' + (index + 1)"
                        class="d-block w-10"
                      />
                    </div>
                    <div v-else>
                      <img
                        v-if="isImage(item)"
                        :src="item.split('|')[0]"
                        :alt="'Slide ' + (index + 1)"
                        class="d-block w-10"
                      />
                      <video v-else class="d-block w-10">
                        <source :src="item.split('|')[0]" type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
            <div class="w-full md:w-5/12 text-xl font-primary">
              <div v-if="modalClickItemData.OFERTA_IO" class="h-8 text-center text-white bg-truered font-bold">PROMO</div>
              <h5 class="modal-title text-left font-bold" id="exampleModalLabel">
                {{ modalClickItemData.DESCRIP_ART }}
              </h5>
              <p
                class="modal-title text-[14px] text-left"
                id="exampleModalLabel"
              >
                Código: {{ modalClickItemData.CODIGO_ART }}
              </p>
              <h5
                v-if="modalClickItemData.PRECIO_LPI"
                class="modal-title text-left text-truered py-2 border-2-black border-t border-b flex items-center gap-1"
              >
                <div v-if="modalClickItemData.DESCUENTO_IO" class="flex items-center gap-1 h-[32px]">
                  <p class="text-lg text-gray-600 line-through">
                    ${{ modalClickItemData.PRECIO_LPI.toFixed(2) }}
                  </p>
                  <p class="text-truered">
                    ${{ (modalClickItemData.PRECIO_LPI * (1 - (Number(modalClickItemData.DESCUENTO_IO) / 100))).toFixed(2) }}
                  </p>
                </div>
                <p v-else class="text-center text-red-600">
                  ${{ modalClickItemData.PRECIO_LPI.toFixed(2) }}
                </p>
                <img v-if="modalClickItemData.INDICACION_IO" class="h-5 w-auto rounded-full p-1 border-black border hover:bg-gray-300 shadow-lg" src="../assets/icons/tooltip.png" alt="indicacion" :title="modalClickItemData.INDICACION_IO">
              </h5>
              <p class="text-lg text-left font-bold">DESCRIPCIÓN</p>
              <p class="text-base text-left">Bulto: {{ modalClickItemData.UXB }}</p>
              <p class="text-base text-left" v-if="modalClickItemData.interno">Int: {{ modalClickItemData.interno }}</p>
              <p class="text-base text-left">Surtido: {{ modalClickItemData.surtido }}</p>
              <p class="text-lg text-left font-bold">CANTIDAD:</p>
              <div class="flex">
                <input
                  class="w-24 border-gray-500 border-1 rounded input-number text-left"
                  @change="agregar(modalClickItemData)"
                  min="1"
                  type="number"
                  @disabled="cargando"
                  @focus="modalClickItemData.cantidadPedida == 0 ? modalClickItemData.cantidadPedida = '' : null"
                  @blur="!modalClickItemData.cantidadPedida ? modalClickItemData.cantidadPedida = 0 : null"
                  v-model="modalClickItemData.cantidadPedida"
                />
              </div>
              <div class="border-2-black border-t border-b my-2">
                <button
                  @disabled="cargando"
                  @click="agregar(modalClickItemData)"
                  class="btn btn-custom-secondary btn-sm my-2"
                >
                  AGREGAR AL CARRITO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End modal click items -->
  </div>
</template>

<script>
import { defineComponent } from "vue";
import pedidosService from "../services/pedidos.service";
import configService from "../services/config.service";
import usuarioService from "../services/usuario.service";
import Carousel from "../components/Carousel.vue"
import { catalogInfiniteScroll } from "../mixins/catalogInfiniteScroll";

export default defineComponent({
  mixins: [catalogInfiniteScroll],
  data() {
    return {
      buscador: "",
      buscadorPasado: "",
      orden: "pd",
      precioDesde: "",
      precioHasta: "",
      errorItem: "",
      modalClickItemData: {},
      categorias: [],
      clientes: [],
      idcli: '',
      expandedMarcas: {}, // Track expanded marcas
      expandedCategorias: {}, // Track expanded categorias
      items: [],
      cargando: false,
      filtroBusqueda: "",
      tipoFiltro: "",
      ultimoIndex: 1,
      listaItemsCarrito: [],
      thumbnailIndex: 0,
      filtroClientes: '',
      filtrosMarca: '',
      banner: ''
    };
  },
  components: {
    Carousel
  },
  mounted() {
    configService.checkHabilitado("CATALOGO")
      .then((res) => {
        if (res.data == 1) {
          this.getConfig()
          this.itemsCarrito();
          this.cargarCategorias();
          this.cargarProductos(1);
          if (!this.esSupervisor && this.esVendedor) {
            this.cargarClientes();
          }
          if (this.esSupervisor) {
            this.cargarTodosLosClientes()
          }
          window.addEventListener("scroll", this.handleScroll);
        } else {
          this.$router.push("/mantenimiento")
        }
      })
      .catch(err => {
        console.log(err)
        this.$router.push("/mantenimiento")
      })
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    cargarTodosLosClientes() {
      usuarioService.getAllClientes()
        .then((res) => {
          this.clientes = res.data.map(c => ({
            id: c.ID_CLI,
            descripcion: c.RAZONSOCIAL_CLI
          }))
          this.idcli = this.clientes[0].id
          this.setCliente()
        })
        .then(() => {
          this.itemsCarrito()
        })
        .catch(err => {
          console.log(err)
        })
    },
    setCliente() {
      console.log('id ' + this.$route.query.c)
      console.log(this.clientes.find(c => c.id == this.$route.query.c))
      if (this.$route.query.c && this.clientes.find(c => c.id == this.$route.query.c)) {
        this.idcli = this.$route.query.c;
      }
    },
    updateIdcli() {
      this.idcli = this.clientesFiltrados[0].id
      this.itemsCarrito()
    },
    getConfig() {
      configService.getCarousel()
        .then((res) => {
          if (res.data == 1) {
            window.$("#carousel").modal("show");
          }
        })
        .catch(err => {
          console.log(err)
        })
      configService.getBannerHab()
        .then((res) => {
          if (res.data == 1) {
            this.getBanner()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getBanner() {
      configService.getBanner()
        .then((res) => {
          console.log(res.data)
          const mediaBlob = new Blob([new Uint8Array(res.data)], { type: 'image/gif' });
          this.banner = URL.createObjectURL(mediaBlob);
          console.log(this.banner)
        })
        .catch(err => {
          console.log(err)
        })
    },
    cargarClientes() {
      usuarioService.getClientes(this.$root.user.id)
        .then((res) => {
          this.clientes = res.data.map(c => ({
            id: c.ID_CLI,
            descripcion: c.RAZONSOCIAL_CLI
          }))
          this.idcli = this.clientes[0].id
          this.setCliente()
        })
        .then(() => {
          this.itemsCarrito()
        })
        .catch(err => {
          console.log(err)
        })
    },
    selectThumbnail(index) {
      this.thumbnailIndex = index;
    },
    isImage(url) {
      return url && url.endsWith("image");
    },
    fetchCatalogPage(index) {
      if (this.hayFiltros) {
        this.buscadorGenerico(index)
      } else {
        this.cargarProductos(index)
      }
    },
    buscarImagenProducto(itemIndex, imageIndex) {
      var item = this.items[itemIndex];
      pedidosService
        .getImagenProducto(item.IDART_IO, imageIndex ? imageIndex : "")
        .then((res) => {
          if (res.data.byteLength === 0 && !imageIndex) {
            this.items[itemIndex].imagen1 = "";
            return;
          }
          const contentType = res.headers["content-type"];

          if (
            contentType &&
            (contentType.startsWith("image/") ||
              contentType.startsWith("video/"))
          ) {
            const mediaBlob = new Blob([res.data], { type: contentType });
            const mediaObjectURL = URL.createObjectURL(mediaBlob);
            const blobUrlWithExtension = `${mediaObjectURL}|${imageIndex}|${
              contentType.startsWith("image/") ? "image" : "video"
            }`;

            if (imageIndex != null) {
              if (!item.carousel) {
                item.carousel = [];
              }

              this.items[itemIndex].carousel.push(blobUrlWithExtension);
              this.items[itemIndex].carousel = this.items[
                itemIndex
              ].carousel.sort((a, b) => {
                return a.split("|")[1] - b.split("|")[1];
              });
              this.modalClickItemData.carousel = this.items[itemIndex].carousel;
            } else {
              this.items[itemIndex].imagen1 = mediaObjectURL;
            }
          } else {
            if (res.data.byteLength === 0 && imageIndex != null) {
              if (!item.carousel) {
                item.carousel = [];
              }
              this.items[itemIndex].carousel.push("|" + imageIndex);
              this.items[itemIndex].carousel = this.items[
                itemIndex
              ].carousel.sort((a, b) => {
                return a.split("|")[1] - b.split("|")[1];
              });
              this.modalClickItemData.carousel = this.items[itemIndex].carousel;
            } else {
              console.error(
                "The response does not contain valid media data. Content-Type:",
                contentType
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetFiltros() {
      this.precioDesde = "";
      this.precioHasta = "";
      this.orden = "pd";
      this.buscador = "";
      this.buscadorPasado = "";
      this.filtrosMarca = ""
      this.filtroBusqueda = "";
      this.buscador = ""
    },
    buscarImagenxItem(index) {
      if (index != null && !this.items[index].imagen1) {
        this.buscarImagenProducto(index, null);
      }
    },
    compararItemsCarrito() {
      this.items.forEach(x => {
        x.id_ic = null
      })
      if (this.listaItemsCarrito.length > 0 && this.items.length > 0) {
        this.items.forEach(x => {
          x.cantidadPedida = 0
          x.obs = ''
        })
        console.log(this.listaItemsCarrito)
        this.listaItemsCarrito.forEach((x) => {
          // buscar item en items y agregar cantidadPedida y id_ic de item carrito
          var itm = this.items.find((a) => a.IDART_IO == x.idart);
          if (itm) {
            itm.cantidadPedida = x.cantidad;
            itm.id_ic = x.id;
            itm.obs = ''
            if (x.obs) {
              itm.obs = x.obs;
            }
          }
        });
      } else if (this.items.length > 0) {
        this.itemsCarrito();
      }
    },
    // filtros de busqueda--------------------------------
    cambioOrdenPrecio(index) {
      this.buscadorGenerico(index)
    },
    
    buscarRango(index) {
      this.buscadorGenerico(index)
    },

    buscarCategoria(ind, filtro, idm, idc, ids) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
      this.filtrosMarca = (filtro + ';' + idm +';' + (idc?idc:'') + ';' + (ids?ids:''))
      this.buscadorGenerico(1)
    },
  
    cambioBuscador(index) {
      this.buscadorGenerico(index)
    },
  
    cargarProductos(index) {
      if (index === 1) {
        this.resetCatalogPagination()
      }
      this.cargando = true;
      this.resetFiltros();
      pedidosService
        .getProductosConIndex(index)
        .then((res) => {
          if (this.tipoFiltro != "" || index == 1) {
            this.items = [];
          }
          this.filtroBusqueda = "";
          this.items.push(...res.data);
          this.cargando = false;
          this.tipoFiltro = "";
          this.compararItemsCarrito(index);
          this.items.forEach((x, i) => {
            this.buscarImagenxItem(i);
          });
          this.onCatalogBatchLoaded(index, res.data.length);
        })
        .catch((err) => {
          console.log(err);
          this.cargando = false;
        });
    },
    buscadorGenerico(index) {
      if (index === 1) {
        this.resetCatalogPagination()
      }
      this.cargando = true
      if (this.hayFiltros) {
        var m = null
        var c = null
        var s = null
        var p = null
        var cat = null
        if (this.filtrosMarca) {
          cat = this.filtrosMarca.split(';')[0] ? this.filtrosMarca.split(';')[0] : null 
          m = this.filtrosMarca.split(';')[1] ? this.filtrosMarca.split(';')[1] : null 
          c = this.filtrosMarca.split(';')[2] ? this.filtrosMarca.split(';')[2] : null 
          s = this.filtrosMarca.split(';')[3] ? this.filtrosMarca.split(';')[3] : null 
        }
        if (this.orden) {
          if (this.orden == 'pMm') {
            p = '1'
          } else if (this.orden == 'pmM') {
            p = '0'
          }
        }
        pedidosService.getProductosFiltrados(index, this.buscador ? this.buscador : this.buscadorPasado, m, c, s, p, this.precioDesde, this.precioHasta )
          .then(res => {
            if (index == 1) {
              this.items = [];
            }
            this.filtroBusqueda = 
            (this.buscador ? this.buscador + ' - ': (this.buscadorPasado ? this.buscadorPasado + ' - ' : '')) +
            (cat ? cat + ' - ': '') +
            (this.precioDesde ? this.precioDesde + ' - ': '') +
            (this.precioHasta ? this.precioHasta : '')
            ;
            if (res.data.length > 0) {
              this.items.push(...res.data);
              this.buscadorPasado = this.buscador ? this.buscador : this.buscadorPasado
              this.buscador = ''
              this.compararItemsCarrito(index);
              this.items.forEach((x, i) => {
                this.buscarImagenxItem(i);
              });
            }
            this.cargando = false
            this.onCatalogBatchLoaded(index, res.data.length);
          })
          .catch((err) => {
            console.log(err)
            this.cargando = false
          })
      } else {
        this.cargarProductos(1)
      }

    },
    // fin filtros de busqueda----------------------------
    toggleMarca(key) {
      // Toggle marca's expanded state
      this.expandedMarcas[key] = !this.expandedMarcas[key];
    },
    toggleCategoria(marcaKey, categoriaKey) {
      // Toggle categoria's expanded state
      if (!this.expandedCategorias[marcaKey]) {
        this.expandedCategorias[marcaKey] = {};
      }
      this.expandedCategorias[marcaKey][categoriaKey] =
        !this.expandedCategorias[marcaKey][categoriaKey];
    },
    formatCategorias(cats) {
      var marcas = [];
      cats.forEach((x) => {
        if (!marcas.includes(x.Marca)) {
          marcas.push(x.Marca);
        }
      });
      marcas = marcas.map((x) => {
        return { marca: x, categorias: [] };
      });
      marcas.forEach((x) => {
        const catsMarca = cats.filter((a) => a.Marca == x.marca);
        x.idmarca = catsMarca[0].IDMARCA_IO;

        x.categorias = catsMarca.reduce((acc, c) => {
          if (!acc.includes(c.Categoria)) {
            acc.push(c.Categoria);
          }
          return acc;
        }, []);

        x.categorias = x.categorias.map((c) => {
          const id = cats.find((a) => a.Marca == x.marca && a.Categoria == c);
          return {
            categoria: c,
            idcat: id.IDCATEGORIA_IO,
            subCategorias: cats.filter((a) => a.Marca == x.marca && a.Categoria == c && a.Subcategoria).map((s) => ({
              subcategoria: s.Subcategoria,
              idsubcat: s.IDSUBCATEGORIA_IO,
            })),
          };
        });
      });
      const customOrder = {
        "Phi Phi Toys": 1,
        "Phi Phi Pets": 2,
        "Ami Toys": 3,
        "Dream Sports": 4,
        "Banana World": 5,
        "Infan-Tec": 6,
      };

      marcas.sort((a, b) => {
        return customOrder[a.marca] - customOrder[b.marca];
      });

      this.categorias = marcas;
      this.abrirTodasLasCategorias();
    },
    abrirTodasLasCategorias() {
      this.categorias.forEach((_, key) => {
        this.expandedMarcas[key] = true;

        this.categorias[key].categorias.forEach((_, categoriaKey) => {
          if (!this.expandedCategorias[key]) {
            this.expandedCategorias[key] = {};
          }
          this.expandedCategorias[key][categoriaKey] = true;
        });
      });
    },
    cargarCategorias() {
      pedidosService
        .getCategorias()
        .then((res) => {
          this.formatCategorias(res.data);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    cargarModalClickItem(key) {
      this.modalClickItemData = this.items[key];
      this.thumbnailIndex = 0;
      if (
        !this.modalClickItemData.carousel ||
        this.modalClickItemData.carousel.length == 0
      ) {
        this.modalClickItemData.carousel = [];
        for (var i = 1; i < 6; i++) {
          if (this.modalClickItemData["FOTO" + i + "_IO"]) {
            this.buscarImagenProducto(key, i);
          }
        }
      }
      window.$("#modalClickItem").modal("show");
    },
    itemsCarrito() {
      var user = JSON.parse(localStorage.getItem("user"));
      if (!this.esVendedor || this.idcli) {
        pedidosService
          .getItemsCarritoClienteSimple(user.id, this.idcli)
          .then((res) => {
            this.$root.itemsCarrito = res.data.length;
            this.listaItemsCarrito = res.data;
            if (res.data.length > 0 && this.items.length > 0) {
              this.compararItemsCarrito();
            } else {
              this.items.forEach(x => {
                x.cantidadPedida = 0
                x.obs = ''
              })
              this.listaItemsCarrito = []
            }
          })
          .catch((err) => {
            console.log(err);
          });          
      }
    },
    agregar(item) {
      this.$nextTick(() => {    
        if (!this.cargando) {
          if (!item.multiplo) {
            item.multiplo = 1
          }
          if (item.IDART_IO && item.cantidadPedida && item.cantidadPedida > 0) {
            console.log(item.multiplo)
            if (item.cantidadPedida % item.multiplo != 0) {
              if (item.cantidadPedida < item.multiplo) {
                item.cantidadPedida = item.multiplo
              } else {
                item.cantidadPedida = Math.round(item.cantidadPedida / item.multiplo) * item.multiplo
              }
            }
            if (this.errorItem) {
              this.errorItem = "";
            }
            var itm = {
              id: item.id_ic ? item.id_ic : null,
              idart: item.IDART_IO,
              cantidad: item.cantidadPedida,
              obs: item.obs ? item.obs : null,
              idcli: this.esVendedor ? this.idcli : null
            };
            window.$("#modalClickItem").modal("hide");
            this.cargando = true;
            pedidosService
              .postItemsCarrito(itm)
              .then(() => {
                this.cargando = false;
                this.$root.alertSuccess = true;
                this.$root.isAlertVisible = true;
                this.items[this.items.indexOf(item)].cantidadPedida = "";
                this.items[this.items.indexOf(item)].obs = "";
                // cartel de exito y borrar datos de "item"
                this.itemsCarrito();
              })
              .catch((err) => {
                this.cargando = false;
                this.$root.alertSuccess = false;
                this.$root.isAlertVisible = true;
                console.log(err);
              });
          // } else if (item.cantidadPedida % item.multiplo != 0) {
          //   this.errorItem = "Este item se vende de a multiplos de " + item.multiplo;
          } else if (item.id_ic) {
            pedidosService
              .deleteItemCarrito(item.id_ic)
              .then(() => {
                this.items[this.items.indexOf(item)].cantidadPedida = "";
                this.itemsCarrito();
                this.$root.alertSuccess = true;
                this.$root.isAlertVisible = true;
              })
              .catch((err) => {
                this.$root.alertSuccess = true;
                this.$root.isAlertVisible = true;
                console.log(err);
              });
          } else {
            this.errorItem = "Debe ingresar una cantidad validad";
          }
        }
      });
    },
  },
  computed: {
    hayFiltros() {
      return this.buscadorPasado || this.buscador || this.filtrosMarca || this.precioDesde || this.precioHasta || this.orden
    },
    clientesFiltrados() {
      if (!this.filtroClientes) {
        return this.clientes
      } else {
        return this.clientes.filter(x => x.descripcion.toLowerCase().includes(this.filtroClientes.toLocaleLowerCase()))
      }
    },
    esVendedor() {
      return this.$root.user.tipo != "cliente";
    },
    esSupervisor() {
      return this.esVendedor && ['admin', 'supervisor'].includes(this.$root.user.tipo)
    }
  },
});
</script>

<style>
.input-number {
  /* Chrome, Safari, Edge, and Opera */
  -webkit-appearance: textfield;
  /* Firefox */
  appearance: textfield;
  /* Remove the up and down arrows */
  -moz-appearance: none;
}

.clickable {
  cursor: pointer;
}

.btn-custom-secondary {
  background-color: rgb(217, 217, 217) !important;
}
.btn-custom-secondary:hover {
  background-color: rgb(241, 29, 29) !important;
  color: white !important;
}

.thumbnails {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.thumbnail {
  width: 50px;
  height: 30px;
  margin: 0 5px;
  cursor: pointer;
}

.thumbnail.active {
  border: 2px solid blue; /* Style for the active thumbnail */
}

.image-container {
    position: relative;
    display: inline-block;
    width: 125px; /* Adjust to fit your image size */
    height: 125px; /* Adjust to fit your image size */
    object-fit: contain;
    overflow: hidden;
}

.image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensures the image scales properly */
}

.sale-banner {
    position: absolute;
    top: 15px;
    left: -45px;
    transform: rotate(-45deg);
    background-color: red;
    color: white;
    padding: 5px 50px;
    font-size: 12px;
    font-weight: bold;
    z-index: 1; /* Ensure it overlays the image */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
</style>
